import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { LocaleService } from '../../../services/locale.service';

@Component({
  selector: 'app-pratica-modifica',
  templateUrl: './pratica-modifica.component.html',
  styleUrls: ['./pratica-modifica.component.css']
})
export class PraticaModificaComponent implements OnInit {
	@Input() data: string = '';
	@Input() writePermission: boolean = false;
	@Input() datiRettifica: string = '';
	@Output() innerEvents = new EventEmitter();

	dataParsed: any = null;
	readOnly: boolean = true;
	editable = true;
	parametri: any = {
	};
	parametriString: string = '{}';

	selectedTemplatesGruppo: any = null;
	templatesGruppi: any[] = [];
	templatesGruppiSync: Subscription;

	selectedEmissione: string = '';
	emissioni: any[] = [];
	emissioniSync: Subscription;

	selectedStato: number = 1;
	statesDictIndex: any[] = [];
	statesDict: any = null;
	statesDictSync: Subscription;

	dettagliPratica: any[] = [];
	praticheDettagliSync: Subscription;

	selectedRow = {
		id: 0,
		crc: 0,
		emissione: "",
		templates_gruppo_id: null,
		emissione_new: false,
		anagrafica_id: null,
		infoPratica: {
			id: null,
			id_prat: null,
			emissione_id: null,
			stato_id: 1,
			stato_data: null,
			protocollo_num: null,
			protocollo_data: null,
			notifica_spese_agg: '0.00',
			notifica_spese_agg_prec: '0.00',
			diritti_pf_agg: '0.00',
			diritti_pf_agg_prec: '0.00',
			note: null
		},
		dettagliPratica: [
			{
				id: null,
				tributo_id: null,
				fasi_id: null,
				anno: null,
				anno_suppl: null,
				dovuto: '0.00',
				arrotondamento: '0.00',
				versato: '0.00',
				sanzioni: '0.00',
				interessi: '0.00',
				notifica_spese: '0.00',
				oneri_risc_attuali: '0.00',
				interessi_agg: '0.00',
				interessi_agg_prec: '0.00',
				sanzioni_agg_prec: '0.00',
				sanzioni_agg: '0.00'
			}
		]
	};
	selectedRowString: string = '';

	constructor(
		private dataService: DataService,
		private formatter: LocaleService
		) {}

	ngOnInit() {
		this.praticheDettagliSync = this.dataService.praticheDettagli$.subscribe(
			() => {
				this.loadFromDB();
			});
		this.templatesGruppiSync = this.dataService.templatesGruppi$.subscribe(
			templatesGruppi => {
				this.templatesGruppi = templatesGruppi;
				this.loadFromDB();
			});
		this.emissioniSync = this.dataService.emissioni$.subscribe(
			emissioni => {
				this.emissioni = emissioni;
				//console.debug('MODIFICA-PRATICA| EMISSIONI', this.emissioni);
			});
		this.statesDictSync = this.dataService.statesDict$.subscribe(
			statesDict => {
				this.statesDict = statesDict;
				this.statesDictIndex = this.dataService.getStatesIndex();
				//console.debug('MODIFICA-PRATICA| STATEDICT', this.statesDict);
			});
		console.debug("MODIFICA-PRATICA| INIT", this.dataParsed);
		this.loadFromDB();
	}

	ngOnChanges(changes: any){
		console.debug("MODIFICA-PRATICA| CHANGE DATA", changes, this.dataParsed);
		if(changes.data) {
			this.loadFromDB();
		}
		if(changes.parametriString) {
			console.log('CHANGE PARAMETRI',this.parametriString);
		}
	}

	aggiornaNewEmissione(){
		console.log("aggiornaNewEmissione", this.selectedRow.emissione_new);
		if(this.selectedRow.emissione_new){
			this.selectedRow.emissione = "";
		}else{
			this.selectedRow.infoPratica.emissione_id = null;
			this.selectedEmissione = null;
			this.selectedTemplatesGruppo = null;
		}
		this.aggiornaValori();
	}

	formatValori(){
		let numberKeys = ['notifica_spese_agg', 'notifica_spese_agg_prec',
		'diritti_pf_agg', 'diritti_pf_agg_prec'];

		for(let key of numberKeys){
			this.selectedRow.infoPratica[key] = this.formatter.nz(this.selectedRow.infoPratica[key]);
			this.selectedRow.infoPratica[key] = this.formatter.twoDigitsDecimal(this.selectedRow.infoPratica[key]).toString();
		}
	}

	aggiornaValori(){
		console.log("aggiornaValori pre", this.selectedRow, "EMISSIONE", this.selectedRow.emissione, "SEL-EMISS", this.selectedEmissione);
		this.selectedRow.templates_gruppo_id = this.selectedTemplatesGruppo;
		this.selectedRow.infoPratica.emissione_id = this.selectedEmissione;
		this.selectedRow.infoPratica.stato_id = this.selectedStato;
		console.log("aggiornaValori post", this.selectedRow);
		this.selectedRowString = JSON.stringify(this.selectedRow);
	}

	loadFromDB(){
		let uid: any = 0;
		this.dataParsed = JSON.parse(this.data);
		console.debug("MODIFICA-PRATICA| LOADFROMDB", this.dataParsed);
		this.selectedRow.id = this.dataParsed.id;
		if(this.dataParsed.person)
			this.selectedRow.anagrafica_id = this.dataParsed.person.anagrafica_id;
		uid = this.dataParsed.uid;
		this.readOnly = this.dataParsed.readOnly;
		this.selectedRow.crc = this.dataParsed.crc;
		this.selectedRow.emissione = "";
		this.selectedRow.emissione_new = false;
		this.aggiornaValori();

		if(this.dataParsed.reset){
			this.parametriString = JSON.stringify(this.parametri);
			this.selectedRow.infoPratica = {
				id: null,
				id_prat: null,
				emissione_id: null,
				stato_id: 1,
				stato_data: null,
				protocollo_num: null,
				protocollo_data: null,
				notifica_spese_agg: '0.00',
				notifica_spese_agg_prec: '0.00',
				diritti_pf_agg: '0.00',
				diritti_pf_agg_prec: '0.00',
				note: null
			};
			this.selectedRow.dettagliPratica = [
				{
					id: null,
					tributo_id: null,
					fasi_id: null,
					anno: null,
					anno_suppl: null,
					dovuto: '0.00',
					arrotondamento: '0.00',
					versato: '0.00',
					sanzioni: '0.00',
					interessi: '0.00',
					notifica_spese: '0.00',
					oneri_risc_attuali: '0.00',
					interessi_agg: '0.00',
					interessi_agg_prec: '0.00',
					sanzioni_agg_prec: '0.00',
					sanzioni_agg: '0.00'
				}
			];
			console.debug("MODIFICA-PRATICA| RESET", this.dataParsed);
			if (this.dataParsed.new_prat) {
				this.selectedEmissione = '';
				this.selectedStato = 1;
				this.selectedRow.infoPratica.id_prat = 'nuovo';
			} else if (this.dataParsed.rev) {
				console.log('pratica rev');
				this.selectedRow.infoPratica = this.dataParsed.praticaRet;
				this.selectedRow.dettagliPratica = this.dataParsed.dettagliRet;
			} else {
				this.dettagliPratica = [];
				if(uid){
					this.dataService.getPraticaById(uid, (localPratica) => {
						this.selectedRow.infoPratica = localPratica;
						console.log("loadFromDB", uid, this.selectedRow.infoPratica);
						this.selectedRow.infoPratica.stato_data = this.formatter.toInternetString(this.selectedRow.infoPratica.stato_data);
						this.selectedRow.infoPratica.protocollo_data = this.formatter.toInternetString(this.selectedRow.infoPratica.protocollo_data);
						this.selectedEmissione = this.selectedRow.infoPratica.emissione_id;
						this.selectedStato = this.selectedRow.infoPratica.stato_id;
						if(Object.keys(this.selectedRow.infoPratica).length){
							this.dataService.getDettagliByUid(this.selectedRow.infoPratica.id, (localDettagli) => {
								this.selectedRow.dettagliPratica = localDettagli;
							});
						}
					});
				}
			}
			this.aggiornaValori();
		}
	}

	newDettaglio(){
		console.log("newDettaglio", this.selectedRow);
		this.selectedRow.dettagliPratica.push({
			id: null,
			tributo_id: null,
			fasi_id: null,
			anno: null,
			anno_suppl: null,
			dovuto: '0.00',
			arrotondamento: '0.00',
			versato: '0.00',
			sanzioni: '0.00',
			interessi: '0.00',
			notifica_spese: '0.00',
			oneri_risc_attuali: '0.00',
			interessi_agg: '0.00',
			interessi_agg_prec: '0.00',
			sanzioni_agg_prec: '0.00',
			sanzioni_agg: '0.00'
		});
		console.debug('MODIFICA-PRATICA| NEW DETTAGLIO', this.selectedRow.dettagliPratica);
	}

	updateDettaglio($event){
		this.selectedRow.dettagliPratica = $event;
		console.debug('MODIFICA-PRATICA| UPDATE DETTAGLIO', this.selectedRow.dettagliPratica);
	}

	ricalcolaSanzioni(){
		console.log("MODIFICA-PRATICA| RICALCOLASANZIONI: ");
		let currentSelectedRow = this.selectedRow;
		console.log("currentSelectedRow", currentSelectedRow, " parametri", this.parametri);

		//	calcolo sanzioni
		this.dataService.ricalcolaSanzioni(currentSelectedRow, (selectedRow) => {
				console.log("MODIFICA-PRATICA| RICALCOLASANZIONI CALLBACK", selectedRow);
				currentSelectedRow = selectedRow;
				this.selectedRow.infoPratica = currentSelectedRow.infoPratica;
				this.selectedRow.dettagliPratica = currentSelectedRow.dettagliPratica;
				this.selectedRowString = JSON.stringify(this.selectedRow);
			});
	}

	commit(){
		this.aggiornaValori();
		let event: any = {
			hide: true,
			selectedRow: this.selectedRow
		};
		if (this.dataParsed.new_prat){
			event.inserisciPratica = true;
		} else if (this.dataParsed.rettifica) {
			event.rettificaPratica = true;
		} else {
			event.modificaPratica = true;
		}
		console.log("MODIFICA-PRATICA|commit", event);
		this.innerEvents.emit(event);
	}

	discard(){
		let event: any = {
			hide: true,
		}
		this.innerEvents.emit(event);
	}

	ngOnDestroy() {
		this.statesDictSync.unsubscribe();
		this.praticheDettagliSync.unsubscribe();
	}
}
